import * as yup from 'yup';

export interface ClaimProps {
  firstName: string;
  lastName: string;
  occurrenceDescription: string;
}

export const schema: yup.SchemaOf<ClaimProps> = yup.object().shape({
  firstName: yup.string().required('Campo Obrigatório'),
  lastName: yup.string().required(),
  occurrenceDescription: yup.string().required('Campo Obrigatório'),
});
